import React, { useEffect, useState } from 'react';
import './WorkRegistrationConsultationFilters.css';
import YoungApprenticeService from '../../services/YoungApprenticeService';

export default function WorkRegistrationConsultationFilters({ Input, filters, setFilters, students = [] }) {
  const [catalog, setCatalog] = useState([]);
  const [error, setError] = useState('');
  useEffect(() => {
    let mounted = true;
    // Historical records must remain searchable after a catalog entry is deactivated.
    YoungApprenticeService.listLookup('terminationReason', { includeInactive: true })
      .then(rows => { if (mounted) setCatalog(Array.isArray(rows) ? rows.map(row => row.name) : []); })
      .catch(() => { if (mounted) setError('Não foi possível carregar os motivos de encerramento cadastrados.'); });
    return () => { mounted = false; };
  }, []);
  const reasons = [...new Set([...catalog, ...students.map(student => student.customFields?.worldOfWorkRecord?.exitReason), filters.wrExitReason].filter(Boolean))].sort((a, b) => a.localeCompare(b, 'pt-BR'));
  const field = (key, label, type = 'date', options) => <Input key={key} label={`${label} — Registro MT`} type={type} value={filters[key] || ''} onChange={event => { const value = event.target.value; setFilters(current => ({ ...current, [key]: value })); }} options={options} />;
  return <div className="students__mt-report-inline">
    <div className="students__mt-report-inline-title">Registro MT</div>
    <div className="students__mt-report-inline-grid students__registration-filter-grid">
      {field('wrEnrollmentStart', 'Inscrição de')}
      {field('wrEnrollmentEnd', 'Inscrição até')}
      {field('wrObservations', 'Observações', 'text')}
      {field('wrExitStart', 'Saída de')}
      {field('wrExitEnd', 'Saída até')}
      {field('wrExitReason', 'Motivo de encerramento', 'text', [{ value: '', label: 'Todos' }, ...reasons.map(value => ({ value, label: value }))])}
    </div>
    {error && <small role="alert">{error}</small>}
  </div>;
}
